<div class="customerDetails" *ngIf="viewModel$ | async as viewModel">
  <div class="firstRow">
    <h2>
      {{ viewModel.header }}
    </h2>

    <app-job-status-dropdown
      *ngIf="viewModel.job"
    ></app-job-status-dropdown>
  </div>
  <div class="secondRow" *ngIf="viewModel.job">
    <a
      [routerLink]="['/jobs', viewModel.job.id, 'overview']"
      [queryParams]="{ zone: authSvc.contextedZoneId }"
      (click)="store.dispatch(actions.jobCodeClicked())"
    >
      {{ viewModel.job.code }}
    </a>
    |
    <span [pTooltip]="viewModel.dateTooltip">
      {{ viewModel.date }}
    </span>
    |
    {{
      viewModel.job?.discountedSubTotal / 100
        | currency: viewModel.job?.currency || 'USD'
    }}
  </div>
  <app-job-tags *ngIf="viewModel.job"></app-job-tags>
</div>
